import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import _ from 'lodash';

import { makeCanonicalTagObj, makeHreflangTagArr } from '@/utils';
import Markdown from '../../components/Markdown';
import Placeholder from '../../components/Placeholder';
import BreadCrumbMenu from '../../components/BreadCrumbMenus/';
import { TABLET_P } from '../../constants';
import { SCREEN_LOCKUP_WIDTH, MOBILE_PADDING } from '../../styles/variables.style';

const Wrapper = styled.div`
  margin: 75px auto;
  max-width: ${SCREEN_LOCKUP_WIDTH + MOBILE_PADDING * 2}px;
  padding: 0 ${MOBILE_PADDING}px;
`;

const MarkdownStyle = styled.div`
  p {
    margin: 40px 0 0 0;
  }

  h1 {
    margin: 0 0 80px 0;
  }

  ol {
    margin: 80px 0 0 0;
  }

  li {
    margin: 70px 0 0 0;
  }
`;

const Date = styled.p`
  color: #ccc;
  font-size: 16px;
  line-height: 1.63;
  letter-spacing: 0.1px;
  margin: 80px 0 0 0;
  text-align: right;
`;

const TermsPage = ({ data, locale, menuInfo }) => (
  <React.Fragment>
    <Helmet
      link={[
        makeCanonicalTagObj(locale, '/terms-of-use'),
        ...makeHreflangTagArr(['All'], '/terms-of-use'),
      ]}  
    />
    {_.get(data, 'metaData') && (
      <Helmet
        title={_.get(data.metaData, 'title')}
        meta={[
          {
            name: 'description',
            content: _.get(data.metaData, 'description'),
          },
          {
            name: 'keyword',
            content: _.get(data.metaData, 'keyword'),
          },
          // TODO: OGP タグは一旦保留 (2020年01月07日)
          // {
          //   property: 'og:url',
          //   content: _.get(data.metaData, 'url'),
          // },
          // {
          //   property: 'og:type',
          //   content: _.get(data.metaData, 'type'),
          // },
          // {
          //   property: 'og:title',
          //   content: _.get(data.metaData, 'title'),
          // },
          // {
          //   property: 'og:image',
          //   content: _.get(data.metaData, 'image.file.url'),
          // },
          // {
          //   property: 'og:description',
          //   content: _.get(data.metaData, 'description'),
          // },
          // {
          //   property: 'og:site_name',
          //   content: _.get(data.metaData, 'siteName'),
          // },
        ]}
      />
    )}
    <Wrapper>
      {data.content ? <Markdown Component={MarkdownStyle} src={data.content} /> : <p>Loading...</p>}
      {data.date && <Date>{`${data.copy.date}: ${data.date}`}</Date>}
    </Wrapper>
    {!(locale && menuInfo && _.get(menuInfo, 'label')) ? (
      <Placeholder w="200px" h="24px" m={window.innerWidth > TABLET_P ? '0 0 20px 40px' : '0 0 20px 20px'} />
    ) : (
      <BreadCrumbMenu
        currentPath={`https://www.shiseido-professional.com/${locale}/terms-of-use`}
        items={[
          {
            name: 'TOP',
            path: `/${locale}/`,
          },
          {
            name: menuInfo.label.toUpperCase(),
            path: null,
          },
        ]}
      />
    )}
  </React.Fragment>
);

TermsPage.defaultProps = {
  data: {},
};

TermsPage.propTypes = {
  // 利用規約メニュー情報
  menuInfo: PropTypes.shape({}).isRequired,
  data: PropTypes.shape(),
};

const mapState = state => ({
  // 利用規約メニュー情報をキャッシュしておく
  menuInfo: state.siteOptions && state.siteOptions.sitemap ? state.siteOptions.sitemap[8] : {},
});

export default connect(mapState)(TermsPage);



// WEBPACK FOOTER //
// ./src/pages/TermsPage/TermsPage.js